import { ChainGroupID } from 'modules/endpoints/types';

import { Tab } from '../hooks/useTabs';

export const sortGroupTabs = (tabs: Tab<ChainGroupID>[]) => {
  if (
    tabs.some(
      tab =>
        tab.id === ChainGroupID.BTC_BLOCKBOOK || tab.id === ChainGroupID.BTC,
    )
  ) {
    return tabs.sort((a, b) => a.id.localeCompare(b.id));
  }

  return tabs;
};
